<div class="bg-default-white">
  <router-outlet></router-outlet>
</div>
